/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps, Theme } from '@mui/material/styles';

export const categoryHeadingSX: SxProps<Theme> = (theme) => ({
	[theme.breakpoints.down('md')]: {
		fontSize: 'var(--font-size-xl)',
	},
});
